import React from 'react';

import { Typography } from '@occc/ui-design-system';
import unitedStates from '@occc-app/lib/constants/unitedStates';
import { ConstraintLocationInStateFragment } from '@occc/graphql';

interface ILocationInStateProps {
  states: ConstraintLocationInStateFragment['states'];
}

const getStatesListString = (states: ConstraintLocationInStateFragment['states']): string =>
  unitedStates
    .filter((us) => states.includes(us.id))
    .map((item) => item.text)
    .join(', ');

export const LocationInState: React.FC<ILocationInStateProps> = ({ states }) => {
  return (
    <>
      <Typography variant='body2' gutterBottom>
        Included states
      </Typography>
      <Typography>{getStatesListString(states)}</Typography>
    </>
  );
};
